import { timeAgo } from '@/lib/utils'
import { FeedPostNotification } from '@/feed/Feed.interface'
import Image from '@/components/common/CardImage'
import CardRichMedia from '@/components/common/CardRichMedia'
import Headline from './components/FeedPostFrontHeadline'
import Text from './components/FeedPostFrontText'
import Cta from './components/FeedPostFrontCta'

function getRichMediaUrl(attrs: {
  provider: string
  richMediaUrl: string
  richMediaCompressedUrl: string
  customData: { type: string }
}): string {
  if (attrs.provider === 'giphy') {
    return attrs.richMediaUrl
  }
  if (attrs.provider === 'external' && attrs.customData.type !== 'mp4') {
    return attrs.richMediaUrl
  }
  return attrs.richMediaCompressedUrl || attrs.richMediaUrl
}

function FeedPostFront({
  feedPostFront,
  campaignGuid,
  sendClickStat,
  sendInAppEvent,
  lastInteractionAt
}: {
  feedPostFront: FeedPostNotification['front']
  campaignGuid: string
  sendClickStat: ({
    campaignGuid,
    buttonNumber
  }: {
    campaignGuid: string
    buttonNumber: number
  }) => void
  lastInteractionAt: number
  sendInAppEvent: (inAppEvents: { name: string; occurredAt: string }[]) => void
}) {
  if (!feedPostFront) return null
  const sortedFront = feedPostFront.sort((a, b) => a.position - b.position)

  return (
    <div className="bg-white pb-2.5">
      <div className="flex justify-center pt-2">
        <div className="mb-2.5 border-2 border-blue-100 inline-block py-1 px-3 rounded text-[10px]/[28px] text-blue-200">
          {timeAgo(lastInteractionAt)}
        </div>
      </div>
      {sortedFront.map((part) => (
        <div key={part.type} className="mb-2.5">
          {part.type === 'headline' && (
            <Headline className="pl-3.5 pr-3.5" text={part.attrs[0].text} />
          )}
          {part.type === 'text' && (
            <Text className="pl-3.5 pr-3.5" text={part.attrs[0].text} />
          )}
          {part.type === 'rich_media' && (
            <CardRichMedia
              provider={part.attrs[0].provider}
              richMediaUrl={getRichMediaUrl(part.attrs[0])}
              richMediaPosterUrl={part.attrs[0].richMediaPosterUrl}
              customData={part.attrs[0].customData}
              imageClassName="max-w-full mb-5 ml-auto mr-auto"
            />
          )}
          {part.type === 'image' && (
            // eslint-disable-next-line jsx-a11y/alt-text
            <Image
              width={part.attrs[0].width}
              height={part.attrs[0].height}
              imageUrl={part.attrs[0].imageUrl}
              name={part.attrs[0].name}
            />
          )}
          {part.type === 'call_to_action' && (
            <Cta
              className="pl-3.5 pr-3.5"
              sendClickStat={sendClickStat}
              sendInAppEvent={sendInAppEvent}
              guid={campaignGuid}
              buttons={part.attrs}
            />
          )}
        </div>
      ))}
    </div>
  )
}

export default FeedPostFront
